import React from 'react';
import { Avatar, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { useAvatar } from '@gamiphy/loyalty-station-desktop/utils/user';

type Props = {
  focus?: boolean
};

const LoggedInButton: React.FC<Props> = observer(() => {
  const avatar = useAvatar();

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <Grid container sx={{ height: '100%' }}>
        <Avatar
          src={avatar}
          sx={{ width: '100%', height: '100%' }}
        />
      </Grid>
    </div>
  );
});

export default LoggedInButton;
